import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from "rxjs";
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class ShareApiService {
  // public SHARE_REQUEST = environment.apiUrl + '/v2/repo/';
  // public POST_SHARE_REQUEST = environment.apiUrl + '/v2/repo/';
  public SHARE_REQUEST = '/v2/repo';
  public POST_SHARE_REQUEST = '/v2/repo';
  public httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{}
  };
  constructor(private http:HttpClient, private apiRequest: ApiRequestService) { }

  getShareData(data): Observable<any>{
    let pathUrl = this.SHARE_REQUEST + "/getshareuser"
    return this.apiRequest.request('POST',pathUrl,data);
    // return this.http.post(this.SHARE_REQUEST + "getshareuser",data, this.httpPostOptions);
  }

  addShareData(data): Observable<any>{
    let pathUrl = this.POST_SHARE_REQUEST + "/sharerepofile"
    return this.apiRequest.request('POST',pathUrl,data);
    // return this.http.post(this.POST_SHARE_REQUEST + "sharerepofile", data, this.httpPostOptions);
  }
}
